const CACHE_PREFIX = 'sfb-core-mapping:v1:'
const CACHE_TTL = 60 * 60 * 1000

const cacheKey = scope => `${CACHE_PREFIX}${scope || 'anonymous'}`

export const readCoreMappingCache = scope => {
  try {
    const cached = JSON.parse(sessionStorage.getItem(cacheKey(scope)))
    if (!cached?.savedAt || !Array.isArray(cached?.rows)) return null
    if (Date.now() - cached.savedAt > CACHE_TTL) {
      sessionStorage.removeItem(cacheKey(scope))
      return null
    }
    return cached.rows
  } catch {
    return null
  }
}

export const writeCoreMappingCache = (scope, rows) => {
  try {
    sessionStorage.setItem(cacheKey(scope), JSON.stringify({
      savedAt: Date.now(),
      rows
    }))
  } catch {
    // Cache is an optimization. Storage quota/privacy mode must not break page.
  }
}

export const invalidateCoreMappingCache = () => {
  try {
    Object.keys(sessionStorage)
      .filter(key => key.startsWith(CACHE_PREFIX))
      .forEach(key => sessionStorage.removeItem(key))
  } catch {
    // Ignore unavailable browser storage.
  }
}
